import React from "react";
import PropTypes from "prop-types";

import SignupOrSeparator from "../SignupOrSeparator";
import EmailSignInForm from "./EmailSignInForm";
import FacebookConnectButton from "../../../FacebookConnectButton/FacebookConnectButton";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";

import style from "../../UserSessionForm.module"

export default class SignInUserPage extends React.Component {
  renderFBConnectButton() {
    return (
      <div className="mt-3">
        <FacebookConnectButton
          onLogin={this.props.onLogin}
          title={I18n.t("login_facebook")}
        />
        <div className="mt-3" />
      </div>
    );
  }

  render() {
    return (
      <div className="sign-user-page">
        {/*<div className="sign-user-page-title">{I18n.t("sign_in_title")}</div>*/}
        <Row>
          <Col sm={8} smPush={2}>
            {this.props.facebookConnectEnabled && this.renderFBConnectButton()}
          </Col>
        </Row>


        <Row>
          <Col sm={8} smPush={2}>
            <EmailSignInForm onLogin={this.props.onLogin} />
          </Col>
        </Row>


        <hr />
        <div className={style.footerText}>
          {I18n.t("pages.user_session.links.not_registered")}{" "}
          <a href="#0" onClick={this.props.signUpButtonClicked}>
            {I18n.t("register")}
          </a>
        </div>
      </div>
    );
  }
}

SignInUserPage.propTypes = {
  signUpButtonClicked: PropTypes.func,
  onLogin: PropTypes.func,
  facebookConnectEnabled: PropTypes.bool
};
